import { forwardRef } from 'react';
import { Box, Skeleton } from '@coolblue-development/freddy';

// Freddy's Menu clones every direct child and injects a ref for keyboard-nav tracking,
// so this needs forwardRef even though it doesn't use the ref itself. Props are spread
// onto the root defensively, though Menu's clone only ever adds `ref`, nothing else.
export const ProfileMenuSkeleton = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <Box ref={ref} {...props}>
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
      <Skeleton variant={'h2'} data-testid="menu-item-skeleton" />
    </Box>
  );
});

ProfileMenuSkeleton.displayName = 'ProfileMenuSkeleton';
